import React, { useCallback } from "react";
import { DropdownProps } from "@fluentui/react-northstar";

import {
  useDeviceTesterDispatchContext,
  useDeviceTesterStateContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";

import { DeviceSelectDropdown } from "./DeviceSelectDropdown";
import { ConnectedDropdownProps } from "./DeviceSelectDropdown.types";

export const ConnectedCamSelectDropdown: React.FC<ConnectedDropdownProps> = ({
  label,
}) => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

  const updateSelectedCam: DropdownProps["onChange"] = useCallback(
    (_: any, data: any) => {
      if (data?.value?.["data-itemid"]) {
        deviceTesterDispatch({
          type: DeviceTesterActionType.SET_SELECTED_CAMERA,
          cameraId: data?.value?.["data-itemid"],
        });
      }
    },
    [deviceTesterDispatch]
  );

  return (
    <DeviceSelectDropdown
      label={label}
      deviceList={deviceTesterState.deviceSettings.cameras}
      selectedDevice={deviceTesterState.deviceSettings.selectedCamera}
      updateSelectedDevice={updateSelectedCam}
    />
  );
};
